import { Component, OnInit, ViewChild } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwGridTableComponent } from 'src/app/librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component';
import { SwMassageConfirmComponent } from 'src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { Router } from '@angular/router';
import { KmsService } from '../../kms.service';
declare var $;
@Component({
  selector: 'app-task-statistic',
  templateUrl: './task-statistic.component.html',
  styleUrls: ['./task-statistic.component.css']
})
export class TaskStatisticComponent implements OnInit {
  @ViewChild("swtable") swtable: SwGridTableComponent;
  @ViewChild("trim") trim: SwMassageConfirmComponent;     //确认删除弹框

  state:string = 'resource';  
  selectIndex = 0;
  timeArr:any = ['全部','本周','本月','本年']
  // 操作日志搜索
  searchDatas: any = {
    requestTime:''  // 创建时间
  };
  // 操作日志表格数据
  datas: any = [];
  // 表格是否显示加载中
  isLoading = false
  // 表格分页组件
  pageBase: any = {
    current: 1,
    size: 10,
  }
  constructor(
    private kmsService: KmsService,
    private box: SwMassageBoxService,
    private router: Router
  ) {
  }
  
  ngOnInit() {;
    this.handleSelectClick();
  }

  //enter键触发搜索
  enterSearch(event) {
    if (event.keyCode == "13") {
      this.handleSelectClick();
    }
  }

  handleReloadClick() {
    // 重置搜索条件
    this.searchDatas = {
      requestTime:''  // 创建时间
    }; 
    this.selectIndex = 0;
    this.handleSelectClick();
  }

  // 查询按钮方法
  handleSelectClick() {
    this.selectIndex = 0;
    this.pageBase = {
      current: 1,
      size: 10,
    };
    this.getData();
  }
 

  // 获取操作日志数据
  getData() {
    // this.isLoading = true;
    // let params = {};
    // if (this.selectIndex == 0) {
    //   const arr = this.searchDatas.requestTime ? this.searchDatas.requestTime.split('#') : ['',''];
    //   params = {
    //     'startEditDate': arr[0],
    //     'endEditDate': arr[1],
    //     'current': this.pageBase.current,
    //     'size': this.pageBase.size
    //   }
    // } else {
    //   params = {
    //     'current': this.pageBase.current,
    //     'size': this.pageBase.size,
    //     'countType': this.selectIndex
    //   }
    // }
    // const func = this.state == 'resource' ? this.kmsService.resourceTaskCount(params) : this.kmsService.instanceTaskCount(params);
    // func.subscribe(
    //   data => {
    //     this.isLoading = false;
    //     if (data.code == '200') {
    //       this.pageBase = data.data;
    //       this.datas = data.data.records;
    //     } else {
    //       this.box.waring(data.msg);
    //     }
    //   }
    // );
  }

  // 表格分页切换方法
  handlePageClick(event) {
    this.pageBase = event;
    this.getData();
  }

  // 选择时间段
  selectTime(i){
    this.selectIndex = i;
    this.searchDatas.requestTime = '';
    this.pageBase = {
      current: 1,
      size: 10,
    };
    this.getData();
  }

  // 切换tab
  setTab(type){
    this.state = type;
    this.handleSelectClick();
  }
}


